export default __webpack_public_path__ + "static/media/website.2a9e31b8.png";